import i18n from '../imports/i18n'
import { humanReadableFormat, rhpToYears } from './formatter'

export const indicators = {
  EntryCosts: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  ExitCosts: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  OngoingCosts: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  TransactionCosts: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  PerformanceCosts: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  RIY: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  RIYRHP: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  TotalCosts: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },

  KIDRHP: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP5070: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP50: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP55: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP60: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP65: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP70: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP75: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP80: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP85: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP90: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  BERHP95: {
    allowDecimal: false,
    formatter: (val) => rhpToYears(val),
    tickInterval: 1,
    min: 1,
    max: 20,
  },
  SharpeRatioOnRiskFree: {
    allowDecimal: true,
    formatter: (val) => humanReadableFormat(val, (formattedVal) => i18n.n(formattedVal, 'decimal')),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  GainLossRatioOnInflation: {
    allowDecimal: true,
    formatter: (val) => humanReadableFormat(val, (formattedVal) => i18n.n(formattedVal, 'decimal')),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  GuaranteeOnPremiumPaid: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  StressReturn: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  UnfavourableReturn: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  ModerateReturn: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  FavourableReturn: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  InsuredEventIncrementRHP: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },

  MRM: {
    allowDecimal: false,
    formatter: (val) => val,
    min: 1,
    max: 7,
    tickAmount: 7,
    binWidth: 0.9999,
  },
  SRI: {
    allowDecimal: false,
    formatter: (val) => val,
    min: 1,
    max: 7,
    tickAmount: 7,
    binWidth: 0.9999,
  },
  VEV: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  VaR: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },

  ModerateGrossReturn: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  RIYGrossReturn: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
  NormalizedReturn: {
    allowDecimal: true,
    formatter: (val) => i18n.n(val, 'percent'),
    min: null,
    max: null,
    tickAmount: null,
    binWidth: null,
  },
}
